import styled from "styled-components";

export const Container = styled.div``

export const Content = styled.main`
  width: calc(100% - 176px);
  height: fit-content;
  margin-left: 176px;
  padding: 45px 0 45.4px;

  position: relative;

  .terms-content__icon-container{
    width: fit-content;
    height: 20px;

    position: absolute;
    top: 29px;
    left: 32px;

    border: 0;
    outline: none;
    background: transparent;
    cursor: pointer;
    transition: filter 0.3s;

    &:hover{
      filter: brightness(1.1);
    }
  }

  .terms-content__icon{
    width: 20px;
    height: 20px;
    stroke: var(--blue00);
  }

  @media (max-width: 1170px){
    width: 100%;
    margin: 0 0 50px 0;
  }
`

export const CardTitle = styled.div`
  width: 90%;
  max-width: 483.56px;
  height: fit-content;
  margin: 0 auto;
  padding: 23px 0 28.7px;

  text-align: center;
  border-radius: 7px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);

  .terms-card__title{
    font-size: 1.5625rem;
    color: var(--blue00);
  }
`

export const Article = styled.article`
  width: 95%;
  max-width: 725.27px;
  height: fit-content;
  margin: 50.6px auto 0;

  color: var(--gray72);
  line-height: 1.75rem;
  white-space: pre-line;
`
